import React from 'react';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Input } from 'semantic-ui-react';
import Server from '../../../functions/server';
import Loading from '../../loadings';
import $ from "jquery";
import Button from '@material-ui/core/Button';

class Upload extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    maxWidth: 'xs',
    files: []
  }


  getFiles() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Upload File!!!');
      return;
    }
    let context = this;
    let date = context.props.date;
    context.setState({ load: true, message: 'Getting File!!!' })
    $.ajax({
      type: 'POST', data: { date },
      url: Server()+ 'Accountings/Chitta/GetFile.php',
      success: function(files) {
        try {
            files = JSON.parse(files);
            context.setState({ files, open: true, load: false })
          } catch (error) {
            alert('Error!!!');
            context.setState({ load: false })
          }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  deleteFile(id, source) {
    if (this.props.machinesalesedit == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'name': source },
      url: Server() + 'purchasedetail/deletefile.php',
      success: function(data)
      {
        if (data == 1) {
          context.getFiles();
        }
        else {
          alert('Error!!!');
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
        });
      }
    });
  }

  submit(file) {
    let context = this;
    var formData = new FormData();
    formData.append('date', context.props.date);
    formData.append('file', file);
    context.setState({ load: true, message: 'Uploading File!!!' })
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'Accountings/Chitta/UploadFile.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          alert('Image Uploaded');
          context.getFiles();
        }
        else {
          alert('Image not upload');
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    });
  }

  changeHandle = name => event => { this.setState({ [name]: event.target.value }); };

  render() {
    let  i = 0;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        { this.props.files > 0 ?
          (
            <CreateNewFolder style={{color: 'green', cursor: 'pointer'}}
              onClick={this.getFiles.bind(this)} />
          ):
          (
            <CreateNewFolder style={{color: 'red', cursor: 'pointer'}}
              onClick={this.getFiles.bind(this)} />
          )
        }
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open}   onClose={ () => { this.setState({ open: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Files</DialogTitle>
          <DialogContent style={{paddingLeft: '4%'}}>
            <DialogContentText>
              { this.state.files.map((x) => {
                  ++i;
                  return (
                    <div style={{padding: '1%', cursor: 'pointer', display: 'flex'}}>
                      <u style={{color: '#6CA1EE'}} onClick={ () => { window.open(x.file) } }>
                        {i+".  "+x.date}
                      </u>
                      <p style={{paddingLeft: '2%'}}>
                        
                      </p>
                    </div>
                  )
                })
              }
              Upload File<br/>
              <input type="file"  name="fileToUpload" id="fileToUpload" onChange={(e) => { this.submit(e.target.files[0])  }}/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Upload;
